import React, { useState } from "react";

import { Trans, useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import BaseModal from "./BaseModal";
import { handleExternalLink } from "../../utils/ExternalLinksHelper";

const PurchaseModal = ({
    showModal,
    setShowModal,
    submitAction,
    isSubmitting,
    model,
}) => {
    const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
    const [numPages, setNumPages] = useState(0);
    const { t } = useTranslation();

    const handleCheckboxChange = () => {
        setIsCheckboxSelected((prevState) => !prevState);
    };

    const onDocumentLoadSuccess = (pdf) => {
        setNumPages(pdf._pdfInfo.numPages);
    };

    const renderPages = () => {
        return Array.from(new Array(numPages), (el, index) => (
            <Page key={index} pageNumber={index + 1} width={700} />
        ));
    };

    return (
        <>
            <BaseModal
                isVisible={showModal}
                setIsVisible={setShowModal}
                title={t("privacyPolicy")}
                action={{
                    name: t("next"),
                    disabled: !isCheckboxSelected,
                    submitAction,
                }}
                isSubmitting={isSubmitting}
                isSmall
            >
                <div className="w-full h-96 px-3 py-2">
                    <div className="h-86 overflow-y-scroll border small-scroll-y small-scroll-x">
                        <Document
                            file={model?.developedBy?.privacyPolicy}
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            {renderPages()}
                        </Document>
                    </div>

                    <div className="ml-3 mt-2">
                        <div className="checkbox-wrapper-input filter-checker-btn">
                            <input
                                type="checkbox"
                                className="checkbox-element"
                                onChange={handleCheckboxChange}
                                id="PrivacyPolicy"
                                checked={isCheckboxSelected}
                            />
                            <label htmlFor="PrivacyPolicy">
                                <p>
                                    <Trans i18nKey="privacyPolicyLabel">
                                        I have read and agree to
                                    </Trans>
                                    <span
                                        className="mr-1 hyperlink"
                                        onClick={() =>
                                            handleExternalLink(
                                                model?.developedBy
                                                    ?.privacyPolicy
                                            )
                                        }
                                    >
                                        <Trans i18nKey="privacyPolicy">
                                            Privacy Policy
                                        </Trans>
                                    </span>
                                    {model?.developedBy?.termsAndConditions && (
                                        <>
                                            and
                                            <span
                                                className="ml-1 hyperlink"
                                                onClick={() =>
                                                    handleExternalLink(
                                                        model?.developedBy
                                                            ?.termsAndConditions
                                                    )
                                                }
                                            >
                                                <Trans i18nKey="termsOfUse">
                                                    termsOfUse
                                                </Trans>
                                            </span>
                                            .
                                        </>
                                    )}
                                </p>
                            </label>
                        </div>
                    </div>
                </div>
            </BaseModal>
        </>
    );
};

export default PurchaseModal;
